export default __webpack_public_path__ + "static/media/empty-cart.3fb2f85a.png";